/**
 * Notification API Service
 * 
 * Handles all API calls related to notifications
 */
import { apiService } from './api.service';

// API endpoints
const ENDPOINTS = {
  NOTIFICATIONS: '/notifications/',
  EVENT_TYPES: '/messages/event-types',
  SUBSCRIBE: '/messages/subscribe',
  UNSUBSCRIBE: '/messages/unsubscribe',
};

class NotificationService {
  async getNotifications(params = {}) {
    try {
      return await apiService.get('/notifications', { params });
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }

  async getFilters(params = {}) {
    try {
      return await apiService.get('/notifications/filters', { params });
    } catch (error) {
      console.error('Error fetching notification filters:', error);
      throw error;
    }
  }

  async getUserSubscriptions(params = {}) {
    try {
      return await apiService.get('/notifications/subscriptions', { params });
    } catch (error) {
      console.error('Error fetching user subscriptions:', error);
      throw error;
    }
  }

  async subscribeToFilter(filterId) {
    try {
      return await apiService.post(`/notifications/subscriptions/${filterId}`);
    } catch (error) {
      console.error('Error subscribing to filter:', error);
      throw error;
    }
  }

  async unsubscribeFromFilter(filterId) {
    try {
      return await apiService.delete(`/notifications/subscriptions/${filterId}`);
    } catch (error) {
      console.error('Error unsubscribing from filter:', error);
      throw error;
    }
  }

  async markAsRead(notificationId) {
    try {
      return await apiService.put(`/notifications/${notificationId}/read`);
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  async deleteNotification(notificationId) {
    try {
      return await apiService.delete(`/notifications/${notificationId}`);
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  }
}

export const notificationService = new NotificationService(); 